import useGetProductBoardToken from '@/services/user/queries/useGetProductBoardToken';

const ProductBoardPortal = () => {
  const { isLoading, isSuccess, data } = useGetProductBoardToken();

  if (isLoading || !isSuccess) return null;

  console.log(data.data);

  return (
    <iframe
      src={`https://portal.productboard.com/gz6dlauvznujmbrmxamkklnj?token=${data.data}`}
      height="1280px"
      width="100%"
    ></iframe>
  );
};

export default ProductBoardPortal;
